/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_Toast_Type_UnavailableInputs */

const en_booking_toast_type_unavailable = /** @type {(inputs: Booking_Toast_Type_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That lesson type isn't available right now. Please call to book.`)
};

const es_booking_toast_type_unavailable = /** @type {(inputs: Booking_Toast_Type_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ese tipo de lección no está disponible ahora. Llama para reservar.`)
};

const de_booking_toast_type_unavailable = /** @type {(inputs: Booking_Toast_Type_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieser Unterrichtstyp ist derzeit nicht verfügbar. Bitte rufen Sie an, um zu buchen.`)
};

const zh_booking_toast_type_unavailable = /** @type {(inputs: Booking_Toast_Type_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`该课程类型目前不可用。请致电预订。`)
};

const ar_booking_toast_type_unavailable = /** @type {(inputs: Booking_Toast_Type_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نوع الدرس هذا غير متاح حالياً. يُرجى الاتصال للحجز.`)
};

const fr_booking_toast_type_unavailable = /** @type {(inputs: Booking_Toast_Type_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce type de cours n'est pas disponible pour le moment. Veuillez appeler pour réserver.`)
};

const vi_booking_toast_type_unavailable = /** @type {(inputs: Booking_Toast_Type_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loại buổi học đó hiện không khả dụng. Vui lòng gọi để đặt.`)
};

const sw_booking_toast_type_unavailable = /** @type {(inputs: Booking_Toast_Type_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aina hiyo ya somo haipatikani kwa sasa. Tafadhali piga simu ili uweke nafasi.`)
};

const th_booking_toast_type_unavailable = /** @type {(inputs: Booking_Toast_Type_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บทเรียนประเภทนั้นไม่พร้อมใช้งานในขณะนี้ กรุณาโทรจอง`)
};

const bs_booking_toast_type_unavailable = /** @type {(inputs: Booking_Toast_Type_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ta vrsta lekcije trenutno nije dostupna. Molimo nazovite da rezervišete.`)
};

const ja_booking_toast_type_unavailable = /** @type {(inputs: Booking_Toast_Type_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このレッスンタイプは現在ご予約いただけません。お電話でご予約ください。`)
};

const ko_booking_toast_type_unavailable = /** @type {(inputs: Booking_Toast_Type_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`해당 레슨 유형은 현재 예약할 수 없습니다. 전화로 예약해 주세요.`)
};

const pt_booking_toast_type_unavailable = /** @type {(inputs: Booking_Toast_Type_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esse tipo de aula não está disponível agora. Por favor, ligue para reservar.`)
};

const it_booking_toast_type_unavailable = /** @type {(inputs: Booking_Toast_Type_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questo tipo di lezione al momento non è disponibile. Chiamaci per prenotare.`)
};

const sv_booking_toast_type_unavailable = /** @type {(inputs: Booking_Toast_Type_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Den här lektionstypen är inte tillgänglig just nu. Ring oss för att boka.`)
};

const nl_booking_toast_type_unavailable = /** @type {(inputs: Booking_Toast_Type_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dat type les is nu niet beschikbaar. Bel alsjeblieft om te boeken.`)
};

const da_booking_toast_type_unavailable = /** @type {(inputs: Booking_Toast_Type_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Den lektionstype er ikke tilgængelig lige nu. Ring for at booke.`)
};

const nb_booking_toast_type_unavailable = /** @type {(inputs: Booking_Toast_Type_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Denne leksjonen er ikke tilgjengelig akkurat nå. Ring for å bestille.`)
};

const fi_booking_toast_type_unavailable = /** @type {(inputs: Booking_Toast_Type_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se oppitunti ei ole saatavilla juuri nyt. Soita varaukseen.`)
};

const pl_booking_toast_type_unavailable = /** @type {(inputs: Booking_Toast_Type_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ten typ lekcji jest teraz niedostępny. Zadzwoń, aby zarezerwować.`)
};

const ru_booking_toast_type_unavailable = /** @type {(inputs: Booking_Toast_Type_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Этот тип урока сейчас недоступен. Позвоните, чтобы записаться.`)
};

const tr_booking_toast_type_unavailable = /** @type {(inputs: Booking_Toast_Type_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu ders türü şu anda mevcut değil. Rezervasyon için lütfen bizi arayın.`)
};

const hi_booking_toast_type_unavailable = /** @type {(inputs: Booking_Toast_Type_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वह पाठ प्रकार अभी उपलब्ध नहीं है। बुक करने के लिए कृपया कॉल करें।`)
};

const id_booking_toast_type_unavailable = /** @type {(inputs: Booking_Toast_Type_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jenis pelajaran itu sedang tidak tersedia. Silakan telepon untuk memesan.`)
};

const ms_booking_toast_type_unavailable = /** @type {(inputs: Booking_Toast_Type_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jenis pelajaran itu tidak tersedia buat masa ini. Sila hubungi kami untuk menempah.`)
};

const cs_booking_toast_type_unavailable = /** @type {(inputs: Booking_Toast_Type_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tento typ lekce teď není k dispozici. Zavolejte nám a zarezervujte si ji.`)
};

const el_booking_toast_type_unavailable = /** @type {(inputs: Booking_Toast_Type_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Αυτός ο τύπος μαθήματος δεν είναι διαθέσιμος τώρα. Παρακαλώ καλέστε για κράτηση.`)
};

const he_booking_toast_type_unavailable = /** @type {(inputs: Booking_Toast_Type_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`סוג השיעור הזה אינו זמין כרגע. אנא התקשרו כדי להזמין.`)
};

const af_booking_toast_type_unavailable = /** @type {(inputs: Booking_Toast_Type_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daardie lestipe is nie nou beskikbaar nie. Bel asseblief om te bespreek.`)
};

const hu_booking_toast_type_unavailable = /** @type {(inputs: Booking_Toast_Type_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ez az óratípus jelenleg nem elérhető. Foglaláshoz hívj minket.`)
};

/**
* | output |
* | --- |
* | "That lesson type isn't available right now. Please call to book." |
*
* @param {Booking_Toast_Type_UnavailableInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const booking_toast_type_unavailable = /** @type {((inputs?: Booking_Toast_Type_UnavailableInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Toast_Type_UnavailableInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_booking_toast_type_unavailable(inputs)
	if (locale === "de") return de_booking_toast_type_unavailable(inputs)
	if (locale === "zh") return zh_booking_toast_type_unavailable(inputs)
	if (locale === "ar") return ar_booking_toast_type_unavailable(inputs)
	if (locale === "fr") return fr_booking_toast_type_unavailable(inputs)
	if (locale === "vi") return vi_booking_toast_type_unavailable(inputs)
	if (locale === "sw") return sw_booking_toast_type_unavailable(inputs)
	if (locale === "th") return th_booking_toast_type_unavailable(inputs)
	if (locale === "bs") return bs_booking_toast_type_unavailable(inputs)
	if (locale === "ja") return ja_booking_toast_type_unavailable(inputs)
	if (locale === "ko") return ko_booking_toast_type_unavailable(inputs)
	if (locale === "pt") return pt_booking_toast_type_unavailable(inputs)
	if (locale === "it") return it_booking_toast_type_unavailable(inputs)
	if (locale === "sv") return sv_booking_toast_type_unavailable(inputs)
	if (locale === "nl") return nl_booking_toast_type_unavailable(inputs)
	if (locale === "da") return da_booking_toast_type_unavailable(inputs)
	if (locale === "nb") return nb_booking_toast_type_unavailable(inputs)
	if (locale === "fi") return fi_booking_toast_type_unavailable(inputs)
	if (locale === "pl") return pl_booking_toast_type_unavailable(inputs)
	if (locale === "ru") return ru_booking_toast_type_unavailable(inputs)
	if (locale === "tr") return tr_booking_toast_type_unavailable(inputs)
	if (locale === "hi") return hi_booking_toast_type_unavailable(inputs)
	if (locale === "id") return id_booking_toast_type_unavailable(inputs)
	if (locale === "ms") return ms_booking_toast_type_unavailable(inputs)
	if (locale === "cs") return cs_booking_toast_type_unavailable(inputs)
	if (locale === "el") return el_booking_toast_type_unavailable(inputs)
	if (locale === "he") return he_booking_toast_type_unavailable(inputs)
	if (locale === "af") return af_booking_toast_type_unavailable(inputs)
	if (locale === "hu") return hu_booking_toast_type_unavailable(inputs)
	return en_booking_toast_type_unavailable(inputs)
});